var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63,23.51a1,1,0,0,0,1-.08A1.09,1.09,0,0,0,10,22.5l0-5.58,4,0V22.5a1.09,1.09,0,0,0,.46.93,1,1,0,0,0,.55.17.88.88,0,0,0,.33-.06A12,12,0,0,0,15.35.48a1,1,0,0,0-.94.09A1.09,1.09,0,0,0,14,1.5l0,5.58-4,0V1.5A1.09,1.09,0,0,0,9.59.57,1,1,0,0,0,8.7.46a12,12,0,0,0-.08,23.05Zm0-21.57V7.11A1.37,1.37,0,0,0,10,8.47h4a1.37,1.37,0,0,0,1.37-1.37V1.94a10.61,10.61,0,0,1,0,20.12V16.89A1.37,1.37,0,0,0,14,15.52H10a1.37,1.37,0,0,0-1.37,1.37v5.17a10.61,10.61,0,0,1,0-20.12Z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52,18a.7.7,0,0,0,.53-1.15A8.3,8.3,0,0,1,4.11,12a.72.72,0,0,0-.73-.66.7.7,0,0,0-.66.73A9.7,9.7,0,0,0,5,17.75.69.69,0,0,0,5.52,18Z",
    fill: "#e30613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,14.24a.69.69,0,0,0,.48.86l.19,0a.7.7,0,0,0,.67-.51,9.7,9.7,0,0,0-.31-6.13.7.7,0,0,0-1.3.51A8.31,8.31,0,0,1,19.5,14.24Z",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokProducts);
export default __webpack_public_path__ + "static/media/hok-products.e0ca64388e4502ce37069796a2940de3.svg";
export { ForwardRef as ReactComponent };